import React from 'react';

import CommentIcon from '../../icons/CommentIcon';

import IconBadge from './IconBadge';

const CommentsBadge = ({ numComments = 0 }) => (
  <IconBadge icon={<CommentIcon />}>{numComments}</IconBadge>
);

export default CommentsBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/CommentsBadge.js